import { createClient } from '@supabase/supabase-js';
const { SUPABASE_URL, SUPABASE_ANON_KEY } = __api.env;
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
const WEEKENDS_TABLE = 'weekends';
const VOTES_TABLE = 'votes';
export const getWeekends = async () => {
    return await supabase
        .from(WEEKENDS_TABLE)
        .select('id, weekend');
};
export const getUserVotes = async (userId) => {
    return await supabase
        .from(VOTES_TABLE)
        .select('weekend_ids')
        .eq('auth_uid', userId);
};
export const postUserVotes = async (userId, weekendIds) => {
    return await supabase
        .from(VOTES_TABLE)
        .upsert({
        auth_uid: userId,
        weekend_ids: weekendIds,
    });
};
